<div class="login">
  <div class="login__form">
    <main role="main" class="form-signin">
      <div class="text-center">
        <img
          id="groweLabLogo"
          src="assets/logo_horiz_dark.png"
          class="mb-3 w-100"
          alt="GroweLab Logo" />
      </div>
      <ng-container *ngIf="errorMessage">
        <div class="alert alert-danger text-start" role="alert">
          {{ errorMessage }}
        </div>
      </ng-container>
      <ng-container *ngIf="request && !errorMessage">
        <h1 class="fs-4 fw-bold mb-3">Authorize Access</h1>
        <p class="text-start">
          <strong>{{ clientDisplayName }}</strong> is requesting access to your
          GroweLab account.
        </p>
        <p class="text-start" *ngIf="user">
          You are signed in as <strong>{{ user.email }}</strong
          >.
        </p>
        <button
          [disabled]="loading"
          data-testid="oauth-authorize-button"
          class="w-100 btn btn-lg btn-primary mb-2 fw-bold"
          (click)="authorize()">
          <span
            *ngIf="loading"
            class="spinner-border spinner-border-sm me-1"></span>
          Authorize
        </button>
        <button
          [disabled]="loading"
          data-testid="oauth-deny-button"
          class="w-100 btn btn-lg btn-outline-secondary mb-4 fw-bold"
          (click)="deny()">
          Cancel
        </button>
      </ng-container>
      <img
        style="max-width: 210px"
        src="/assets/powered-by-e2l-logo.png"
        alt="Powered by engage2Learn"
        title="Powered by engage2Learn" />
      <div class="fw-light">
        All rights reserved.
        <a
          href="legal/privacy-policy"
          aria-label="link to engage2learn privacy policy"
          >Privacy</a
        >
        |
        <a href="legal/terms" aria-label="link to engage2learn terms of use"
          >Terms</a
        >
      </div>
    </main>
  </div>
</div>
